import dayjs from 'dayjs'

export const formatTime = (time: number, format?: string): string => {
    return dayjs(time).format(format || 'LLL')
}
